import { render } from "./RoleManagementTab.vue?vue&type=template&id=e05493e2"
import script from "./RoleManagementTab.vue?vue&type=script&lang=js"
export * from "./RoleManagementTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__